module.exports = __webpack_public_path__ + "assets/img/aeb74eeb9cad785ef9934c14e20eb492.png";